import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Learn14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.49239 1.89507C7.17795 1.76032 6.82203 1.76032 6.50759 1.89508L0.776888 4.35109C-0.233248 4.78401 -0.233245 6.21604 0.776888 6.64895L2.25002 7.2803L2.25 10C2.25 10.1164 2.27711 10.2313 2.32918 10.3354L2.33001 10.3371L2.33095 10.3389C2.57922 10.8268 2.98464 11.2482 3.40647 11.5857C4.15486 12.1844 5.3178 12.75 7 12.75C8.68218 12.75 9.84512 12.1844 10.5935 11.5857C11.0153 11.2482 11.4208 10.8267 11.6691 10.339L11.67 10.3371C11.6712 10.3347 11.6708 10.3354 11.6708 10.3354C11.7229 10.2313 11.75 10.1164 11.75 10V7.28027L12.25 7.066V8.5C12.25 8.91421 12.5858 9.25 13 9.25C13.4142 9.25 13.75 8.91421 13.75 8.5V6.22989C14.1825 5.62441 14.0069 4.68699 13.2231 4.35109L7.49239 1.89507ZM1.90393 5.50002L6.99999 3.316L12.096 5.50002L6.99999 7.68405L1.90393 5.50002ZM10.25 7.92313L7.49239 9.10497C7.17796 9.23973 6.82203 9.23973 6.50759 9.10497L3.75001 7.92315L3.75 9.78887C4.4673 10.8251 5.78794 11.25 7 11.25C8.21395 11.25 9.5324 10.8255 10.25 9.78885V7.92313Z'
      fill='currentColor'
    />
  </Svg>
);

Learn14.displayName = 'Learn14';
export default Learn14;
